// extracted by mini-css-extract-plugin
export default {"root":"Nav_root__UGBIh","navLink":"Nav_navLink__NGbdu","activeNavLink":"Nav_activeNavLink__Apiy-"};